import { Box, FormHelperText, Rating, Typography } from '@mui/material';
import { UseControllerReturn } from 'react-hook-form';
import { FieldProps } from '@/classes/types';
import Field from '../Field';

function RatingComponent({ field, fieldModel, fieldState }: FieldProps<RatingField>) {
  const helperText = fieldModel.getHelperText(fieldState);

  return (
    <Box>
      {fieldModel.label && <Typography component="legend">{fieldModel.label}</Typography>}
      <Rating
        sx={{
          '& .MuiRating-iconFilled': {
            color: fieldModel.hexColor,
          },
          '& .MuiRating-iconHover': {
            color: fieldModel.hexColor,
          },
        }}
        value={field.value}
        onChange={(e, v) => field.onChange(v)}
        max={10}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </Box>
  );
}

export default class RatingField extends Field {
  hexColor: string | undefined;

  constructor(name: string) {
    super(name);
  }

  renderEditComponent(props: UseControllerReturn) {
    return <RatingComponent {...props} fieldModel={this} />;
  }
}
